import axios from "axios";
import { getApiErrorMessage } from "../../utils/apiError";
import { formatRefillDate } from "./InteractiveAiUsageBar";
import { nicheErrorCode, nicheErrorExtra } from "./nicheApi";

export interface NicheErrorView {
    text: string;
    exhausted?: { resetsOn: string | null };
    profileRequired?: boolean;
    topicGone?: boolean;
}

const AI_FAILED = "We couldn't write that just now. Try again.";

export const refillText = (resetsOn: string | null): string =>
    resetsOn
        ? `Your AI allowance refills on ${formatRefillDate(resetsOn)}.`
        : "Your AI allowance refills at your next billing date.";

// What the Topic & script step shows for a failed /niche call (spec §8).
export const describeNicheError = (error: unknown): NicheErrorView => {
    switch (nicheErrorCode(error)) {
        case "AI_ALLOWANCE_EXHAUSTED": {
            const resetsOn = nicheErrorExtra<string>(error, "resetsOn") ?? null;
            return { text: refillText(resetsOn), exhausted: { resetsOn } };
        }
        case "AI_RATE_LIMITED":
            return { text: "Give it a moment and try again." };
        case "NICHE_AI_FAILED":
            return { text: AI_FAILED };
        case "NICHE_TOPIC_REJECTED":
            return { text: nicheErrorExtra<string>(error, "reason") || getApiErrorMessage(error, "Let's keep it to real estate.") };
        case "NICHE_NOT_ELIGIBLE":
            // The entry only shows to eligible agents; this is a plan change mid-post.
            return { text: "My Niche is part of AI Pro." };
        case "NICHE_PROFILE_REQUIRED":
            return { text: "Set up My Niche first.", profileRequired: true };
        case "NICHE_TOPIC_NOT_FOUND":
            return { text: "That topic is gone. Pick another.", topicGone: true };
    }
    if (axios.isAxiosError(error) && error.response?.status === 502) return { text: AI_FAILED };
    return { text: getApiErrorMessage(error, "Something went wrong. Try again.") };
};
